import {
  V2CircuitListPostResponse,
  V2DistributionCabinetListCircuitWithDataPostResponse,
  V2DistributionCabinetListPostResponse,
  V2DistributionCabinetListWithCircuitByRoomIdPostResponse,
  V2DistributionCabinetMonitorListPostResponse,
  V2DistributionCabinetRoomCabinetTreePostResponse,
} from '@maxtropy/device-customer-apis-v2';

export type RoomItem = Exclude<V2DistributionCabinetRoomCabinetTreePostResponse['list'], undefined>[number];

export type CabinetItem = Exclude<V2DistributionCabinetListPostResponse['list'], undefined>[number];
export type MonitorItem = Exclude<V2DistributionCabinetMonitorListPostResponse['list'], undefined>[number];

export type CircuitItem = Exclude<V2CircuitListPostResponse['list'], undefined>[number];

export type RoomListCircuitWithDataItem = Exclude<
  V2DistributionCabinetListWithCircuitByRoomIdPostResponse['list'],
  undefined
>[number];

export type RoomListCabinetListCircuitItem = Exclude<RoomListCircuitWithDataItem['circuitList'], undefined>[number];

export type CabinetListCircuitWithDataItem = Exclude<
  V2DistributionCabinetListCircuitWithDataPostResponse['list'],
  undefined
>[number];

export type FunCallback = (nodeData: any) => void;

export enum NodeType {
  ROOM = 0,
  CABINET = 1,
}

export const levelOptions = [
  { value: 0, label: '1级' },
  { value: 1, label: '2级' },
  { value: 2, label: '3级' },
  { value: 3, label: '4级' },
  { value: 4, label: '5级' },
  { value: 5, label: '6级' },
  { value: 6, label: '7级' },
  { value: 7, label: '8级' },
  { value: 8, label: '9级' },
  { value: 9, label: '10级' },
];

export const levelDisplay: Record<number, string> = {
  1: '一级',
  2: '二级',
  3: '三级',
  4: '四级',
  5: '五级',
  6: '六级',
  7: '七级',
  8: '八级',
  9: '九级',
  10: '十级',
};

// 视频接入方式
export enum VideoAccessType {
  // 外高桥
  SWS = 1,
}
